import React from 'react'
import { StyleService, useStyleSheet } from '@src/style/service'
import { InlineAlert } from '@components'
import {
  EhrAppointmentAttendanceChargeKind,
  EhrAppointmentStateKind,
  UiInlineAlert,
} from '@src/types'
import { INSURANCE_CHECK_IN_PROGRESS_MESSAGE } from '../../constants'

interface InsuranceCoverageDetailsProps {
  chargeKind: EhrAppointmentAttendanceChargeKind | null | undefined
  appointmentState: EhrAppointmentStateKind
}

export const InsuranceCoverageDetails = ({
  chargeKind,
  appointmentState,
}: InsuranceCoverageDetailsProps) => {
  const styles = useStyleSheet(themedStyles)

  const isInsuranceCovered = chargeKind === EhrAppointmentAttendanceChargeKind.BsInsuranceCovered
  const isInReview = appointmentState === EhrAppointmentStateKind.InReview

  if (!isInsuranceCovered || !isInReview) {
    return null
  }

  return (
    <InlineAlert
      category={UiInlineAlert.Warning}
      message={INSURANCE_CHECK_IN_PROGRESS_MESSAGE}
      style={styles.container}
    />
  )
}

const themedStyles = StyleService.create({
  container: {
    marginTop: 24,
    marginBottom: 12,
  },
})
